import { FORTA_BLUE } from '../../utils/colors';

import type { IconProps } from './types';

const EditIconBordered = (props: IconProps) => {
  const { color = FORTA_BLUE.primary, width = 24, height = 24 } = props;

  return (
    <svg
      width={`${width}`}
      height={`${height}`}
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      overflow="visible"
      style={{ display: 'block' }}
    >
      <rect x="1.5" y="1.5" width="41" height="41" rx="7.5" stroke={color} />
      <path
        d="M29 10.8128C29.2626 10.5502 29.5744 10.3418 29.9176 10.1997C30.2608 10.0575 30.6286 9.98438 31 9.98438C31.3714 9.98437 31.7392 10.0575 32.0824 10.1997C32.4256 10.3418 32.7374 10.5502 33 10.8128C33.2626 11.0755 33.471 11.3873 33.6131 11.7304C33.7553 12.0736 33.8284 12.4414 33.8284 12.8128C33.8284 13.1842 33.7553 13.552 33.6131 13.8952C33.471 14.2384 33.2626 14.5502 33 14.8128L19.5 28.3128L14 29.8128L15.5 24.3128L29 10.8128Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default EditIconBordered;
